export default "__VITE_ASSET__67693939__"